import React from 'react';

import { InfoBox } from '@infoods/lifebase-ui';
import classes from './RevenuePerformanceSummary.module.scss';
import { TotalAmountChart } from './TotalAmountChart/TotalAmountChart';
import { TotalAmountGraph } from './TotalAmountGraph/TotalAmountGraph';
import { RevenueGeneralFilterValues } from '../DetailedRevenue.settings';

type RevenuePerformanceSummaryProps = {
  entityId: number;
  generalFilters: RevenueGeneralFilterValues;
};

const RevenuePerformanceSummary = ({
  entityId,
  generalFilters,
}: RevenuePerformanceSummaryProps) => {
  return (
    <InfoBox title="Revenue Performance Summary">
      <div className={classes.box}>
        <TotalAmountChart entityId={entityId} generalFilters={generalFilters} />
        <TotalAmountGraph entityId={entityId} generalFilters={generalFilters} />
      </div>
    </InfoBox>
  );
};

export { RevenuePerformanceSummary };
